import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  connected$ = new BehaviorSubject<boolean>(false);
  eventsData$ = new Subject();

  constructor(
    private authService: AuthService,
    private socket: Socket
  ) {}

  initSocket(): void {
    this.authService.authUser.subscribe((user) => {
      if (user) {
        this.socket.ioSocket.auth = { token: this.authService.accessToken };
        this.connect();
        this.addSocketEventsListener();
        return;
      }
      this.disconnect();
    })
  }

  addSocketEventsListener(): void {
    // Socket Events
    this.socket.on('connect', () => {
      this.connected$.next(true);
    });

    this.socket.on('connect_error', (err: any) => {
      this.connected$.next(false);
      this.connect();
    });

    this.socket.on('disconnect', (reason: any) => {
      this.connected$.next(false);
      if (reason === 'io server disconnect') {
        // the disconnection was initiated by the server, you need to reconnect manually
        this.connect();
      }
      // else the socket will automatically try to reconnect
    });

    // Custom Events
    this.socket.on('events', (data: any) => {
      this.eventsData$.next(data);
    });

    this.socket.on('exception', (e: any) => {});
  }

  connect(): void {
    this.socket.connect();
  }

  disconnect(): void {
    this.socket.disconnect();
  }

  getEventsMessage(): Observable<string> {
    return this.socket
      .fromEvent<any>('events')
      .pipe(
        map(data => data.msg)
      );
  }

  sendEventsMessage(msg: string): void {
    this.socket.emit('events', msg);
  }

  joinRoom(room: string): void {
    this.socket.ioSocket.join(room);
  }

  joinRooms(rooms: string[]): void {
    for (let i = 0; i < rooms.length; i++) {
      this.joinRoom(rooms[i]);
    }
  }

  leaveRoom(room: string): void {
    this.socket.ioSocket.leave(room);
  }

  leaveRooms(rooms: string[]): void {
    for (let i = 0; i < rooms.length; i++) {
      this.leaveRoom(rooms[i]);
    }
  }
}
